import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from '../../utils/Breakpoints';
import { colors, boxshadow } from '../../utils/config';

import MenuItem from './menuitem';

const StyledCategoryMenu = styled.div`
	width: 96%;
	width: calc(100% - 16px);
	height: ${props => (props.menuExtended ? 'auto' : '72px')};
	margin-left: auto;
	margin-right: auto;
	border-radius: 5px;
	border: 1px solid ${colors.graylight};
	background-color: ${colors.white};
	box-shadow: ${boxshadow.categorymenu};
	margin-bottom: 8px;
	overflow: hidden;
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;

	${media.iphone`
		max-width: 358px;
	`}

	${media.lg`
		width: 460px;
		max-width: none;
		height: ${props => (props.menuExtended ? 'auto' : '96px')};
	`}

	@media screen and (min-width: 1366px) and (max-height: 768px) and (orientation: landscape) {
		transform: scale(0.752);
		transform-origin: top left;
	}

	${props =>
		props.dockedAtSearchbar &&
		`
		position: fixed;
		top: 55px;
		margin-left: 8px;
		border-top-left-radius: 0;
		border-top-right-radius: 0;
		z-index: 30;
	`}

	${props =>
		props.dockedAtSearchbar &&
		media.lg`
		top: 83px;
		margin-left: 16px;
	`}

	@media screen and (min-width: 1366px) and (max-height: 768px) and (orientation: landscape) {
		${props =>
			props.dockedAtSearchbar &&
			`
			top: 50px;
			margin-left: 16px;
		`}
	}

	${props =>
		props.dockedAtSearchbar &&
		media.xl`
		top: 99px;
		margin-left: 32px;
	`}
`;

function CategoryMenu({ items, type, dockedAtSearchbar, setFilters, activeMenuItem }) {
	const [menuExtended, setMenuExtended] = useState(false);

	let listLimit = 6;
	if (menuExtended) {
		listLimit = 100;
	}

	return (
		<StyledCategoryMenu
			type={type}
			dockedAtSearchbar={dockedAtSearchbar}
			menuExtended={menuExtended}
			activeMenuItem={activeMenuItem}
		>
			{items.slice(0, listLimit).map(item => (
				<MenuItem
					key={item.id}
					title={item.title}
					subtitle={item.subtitle}
					icon={item.icon}
					image={item.image}
					type={type}
					active={item.titlefilter === activeMenuItem}
					onClick={() => {
						if (item.isShowMore) {
							setMenuExtended(!menuExtended);
						} else {
							setFilters(item.filter);
							// this.setState({
							// 	activeItem: item.title,
							// });
						}
						if (typeof _paq !== 'undefined' && typeof item.trackData !== 'undefined') {
							// eslint-disable-next-line no-underscore-dangle
							window._paq.push(['trackEvent', ...item.trackData]);
						}
					}}
				/>
			))}
		</StyledCategoryMenu>
	);
}

CategoryMenu.propTypes = {
	items: PropTypes.array,
	type: PropTypes.oneOf(['oepnv', 'sharing', 'places', 'tips']),
	dockedAtSearchbar: PropTypes.bool,
	activeMenuItem: PropTypes.string,
	setFilters: PropTypes.func,
};

CategoryMenu.defaultProps = {
	setFilters: () => {},
};

export default CategoryMenu;
